import {
  Identifiable,
  CostProfile,
  CostProfileCostsHistory,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getCostProfileCostsHistory(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<CostProfile>) =>
    httpClient
      .sendHttpRequest<{
        _embedded: { costProfileHistories: CostProfileCostsHistory };
      }>({
        endpoint: `/costProfiles/${uuid}/costProfileHistories?size=9999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.costProfileHistories);
}

export { getCostProfileCostsHistory };
